var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"align-center justify-center",model:{value:(_vm.showOverlay),callback:function ($$v) {_vm.showOverlay=$$v},expression:"showOverlay"}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }